import Backend from "./Backend";
import {selectedCompanyStore} from "../store/SelectedCompany";
import {BaseMatchedTransaction} from "../model/MatchedDocument";
import {ResultOrErrorDto} from "../model/ResultOrErrorDto";

class AnalyzedTransactionApi {

    public markAsSent(txs: BaseMatchedTransaction[]): Promise<void> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.post(`/api/v1/company/${companyId}/statement/analyzed/mark_sent`, txs);
    }

    public send(tx: BaseMatchedTransaction): Promise<ResultOrErrorDto<boolean>> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.post(`/api/v1/company/${companyId}/statement/analyzed/send`, tx);
    }

}

export const analyzedTransactionApi = new AnalyzedTransactionApi();